const { prop } = require('ramda');
module.exports = value =>
  `${prop('status')(value)} (${prop('paid')(value)} of ${prop('owed')(
    value
  )} paid)`;
